import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { defaultAppTitle } from '../config/functions';
import { Hero } from '../components';
import { Link } from 'react-router-dom';

class Error404 extends Component {
    render() {
        return (
            <Hero showHint={false}>
                <Helmet>
                    <title>{`Page not found // ${defaultAppTitle}`}</title>
                </Helmet>
                
                <h1 className="alpha">
                    Sorry, the page you requested could not be found. <Link to="/">Go home</Link>
                </h1>
                <p></p>
            </Hero>
        );
    }
}

export default Error404;



// WEBPACK FOOTER //
// ./src/pages/Error404.js